import { render, staticRenderFns } from "./ModelRendering.vue?vue&type=template&id=557e7fe5&scoped=true&"
import script from "./ModelRendering.vue?vue&type=script&lang=js&"
export * from "./ModelRendering.vue?vue&type=script&lang=js&"
import style0 from "./ModelRendering.vue?vue&type=style&index=0&id=557e7fe5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557e7fe5",
  null
  
)

export default component.exports